var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.loading),expression:"loading",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"loading-content",attrs:{"element-loading-text":"加载中...","element-loading-background":"rgba(0, 0, 0, 0.5)"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }